// Editor runtime injected into the preview iframe (edit mode only).
// All editing logic lives inside the iframe and talks to the parent via postMessage.

const EDITOR_CSS = `
[data-edit-id]{cursor:pointer;}
.__ed-hover{outline:2px dashed rgba(0,240,255,.65)!important;outline-offset:1px;}
.__ed-selected{outline:2px solid #00F0FF!important;outline-offset:1px;}
[contenteditable=true]{cursor:text;outline:2px solid #00F0FF!important;}
`;

const EDITOR_JS = `
(function(){
  var SEL=null, HOV=null, MOVE=false;
  var dragging=false, resizing=false, sx=0, sy=0, bx=0, by=0, rw=0, rh=0, handle=null;
  function uid(){return 'e'+Math.random().toString(36).slice(2,9);}
  function initIds(){
    var nodes=document.body?document.body.querySelectorAll('*'):[];
    for(var i=0;i<nodes.length;i++){ if(!nodes[i].getAttribute('data-edit-id')) nodes[i].setAttribute('data-edit-id',uid()); }
  }
  function q(id){return document.querySelector('[data-edit-id="'+id+'"]');}
  function canEditText(el){return el.children.length===0 && el.textContent.trim().length>0 && el.tagName!=='IMG';}
  function isText(el){
    var t=['P','H1','H2','H3','H4','H5','H6','SPAN','A','BUTTON','LI','LABEL','BLOCKQUOTE','FIGCAPTION','STRONG','EM','SMALL','TD','TH'];
    return t.indexOf(el.tagName)>=0 || canEditText(el);
  }
  function info(el){
    var cs=getComputedStyle(el);
    return {
      id: el.getAttribute('data-edit-id'),
      tag: el.tagName.toLowerCase(),
      isImage: el.tagName==='IMG',
      isText: isText(el),
      canEditText: canEditText(el),
      isLink: el.tagName==='A',
      src: el.tagName==='IMG'? (el.getAttribute('src')||''):null,
      href: el.tagName==='A'? (el.getAttribute('href')||''):null,
      color: cs.color,
      bgColor: cs.backgroundColor,
      fontSize: parseInt(cs.fontSize)||16,
      fontWeight: cs.fontWeight,
      textAlign: cs.textAlign,
      radius: parseInt(cs.borderTopLeftRadius)||0
    };
  }
  function clearSel(){
    if(SEL){SEL.classList.remove('__ed-selected'); SEL.removeAttribute('contenteditable');}
    SEL=null; hideHandle();
  }
  function select(el){
    clearSel();
    SEL=el; el.classList.add('__ed-selected');
    if(!MOVE && canEditText(el)){ el.setAttribute('contenteditable','true'); try{el.focus();}catch(e){} }
    if(MOVE){ showHandle(); }
    parent.postMessage({__editor:true,type:'selected',payload:info(el)},'*');
  }
  function ensureHandle(){
    if(handle)return;
    handle=document.createElement('div');
    handle.className='__ed-ui';
    handle.style.cssText='position:fixed;width:16px;height:16px;background:#00F0FF;border:2px solid #fff;border-radius:4px;cursor:nwse-resize;z-index:2147483647;display:none;box-sizing:border-box;';
    document.body.appendChild(handle);
    handle.addEventListener('mousedown',function(e){ e.preventDefault(); e.stopPropagation(); if(!SEL)return; resizing=true; var r=SEL.getBoundingClientRect(); rw=r.width; rh=r.height; sx=e.clientX; sy=e.clientY; });
  }
  function posHandle(){ if(!handle||!SEL)return; var r=SEL.getBoundingClientRect(); handle.style.left=(r.right-8)+'px'; handle.style.top=(r.bottom-8)+'px'; }
  function showHandle(){ ensureHandle(); if(MOVE&&SEL){ handle.style.display='block'; posHandle(); } }
  function hideHandle(){ if(handle) handle.style.display='none'; }

  document.addEventListener('mouseover',function(e){
    var el=e.target; if(!el||el===document.body||el.tagName==='HTML')return;
    if(el.classList&&el.classList.contains('__ed-ui'))return;
    if(HOV&&HOV!==el)HOV.classList.remove('__ed-hover');
    if(el!==SEL){el.classList.add('__ed-hover');HOV=el;}
  },true);
  document.addEventListener('mouseout',function(e){ if(e.target&&e.target.classList)e.target.classList.remove('__ed-hover'); },true);
  document.addEventListener('click',function(e){
    var el=e.target; if(!el||el===document.body||el.tagName==='HTML')return;
    if(el.classList&&el.classList.contains('__ed-ui'))return;
    e.preventDefault(); e.stopPropagation(); select(el);
  },true);
  document.addEventListener('submit',function(e){e.preventDefault();},true);

  document.addEventListener('mousedown',function(e){
    if(!MOVE||!SEL)return;
    var t=e.target;
    if(t.classList&&t.classList.contains('__ed-ui'))return;
    if(t!==SEL && !SEL.contains(t))return;
    dragging=true;
    sx=e.clientX; sy=e.clientY;
    bx=parseFloat(SEL.getAttribute('data-tx')||'0');
    by=parseFloat(SEL.getAttribute('data-ty')||'0');
    e.preventDefault();
  },true);
  document.addEventListener('mousemove',function(e){
    if(resizing&&SEL){
      var w=Math.max(20,rw+(e.clientX-sx)); var h=Math.max(20,rh+(e.clientY-sy));
      SEL.style.width=w+'px'; SEL.style.height=h+'px'; posHandle();
    } else if(dragging&&SEL){
      var nx=bx+(e.clientX-sx); var ny=by+(e.clientY-sy);
      SEL.setAttribute('data-tx',nx); SEL.setAttribute('data-ty',ny);
      SEL.style.transform='translate('+nx+'px,'+ny+'px)'; posHandle();
    }
  },true);
  document.addEventListener('mouseup',function(){ dragging=false; resizing=false; },true);
  document.addEventListener('scroll',function(){ posHandle(); },true);

  function sectionEls(){
    var out=[]; var ch=document.body?document.body.children:[];
    for(var i=0;i<ch.length;i++){ var el=ch[i]; var t=el.tagName;
      if(t==='SCRIPT'||t==='STYLE')continue;
      if(el.id==='__editor_style'||el.id==='__editor_script')continue;
      if(el.classList&&el.classList.contains('__ed-ui'))continue;
      out.push(el);
    }
    return out;
  }
  function labelFor(el){
    var t=(el.textContent||'').trim().replace(/\\s+/g,' ').slice(0,40);
    var tag=el.tagName.toLowerCase();
    return t?(tag+' · '+t):tag;
  }
  function postSections(){
    var els=sectionEls(); var list=[];
    for(var i=0;i<els.length;i++){ var el=els[i];
      if(!el.getAttribute('data-edit-id'))el.setAttribute('data-edit-id',uid());
      list.push({id:el.getAttribute('data-edit-id'),label:labelFor(el)});
    }
    parent.postMessage({__editor:true,type:'sections',list:list},'*');
  }
  function reorder(order){ var body=document.body; for(var i=0;i<order.length;i++){var el=q(order[i]); if(el)body.appendChild(el);} }
  function insertSection(h){
    var tmp=document.createElement('div'); tmp.innerHTML=h;
    var node=tmp.firstElementChild; if(!node)return;
    var sc=document.getElementById('__editor_script');
    if(sc) document.body.insertBefore(node,sc); else document.body.appendChild(node);
    initIds();
  }

  window.addEventListener('message',function(e){
    var d=e.data||{}; if(!d.__cmd)return;
    if(d.cmd==='style'){ var el=q(d.id); if(el){el.style[d.prop]=d.value; if(SEL===el){ parent.postMessage({__editor:true,type:'selected',payload:info(el)},'*'); if(MOVE)posHandle(); }} }
    else if(d.cmd==='src'){ var el=q(d.id); if(el) el.setAttribute('src',d.value); }
    else if(d.cmd==='href'){ var el=q(d.id); if(el) el.setAttribute('href',d.value); }
    else if(d.cmd==='deselect'){ clearSel(); }
    else if(d.cmd==='delete'){ var el=q(d.id); if(el){el.remove(); clearSel();} postSections(); }
    else if(d.cmd==='getsections'){ postSections(); }
    else if(d.cmd==='reorder'){ reorder(d.order||[]); postSections(); }
    else if(d.cmd==='insertSection'){ insertSection(d.html||''); postSections(); }
    else if(d.cmd==='setmove'){ MOVE=!!d.enabled; if(SEL){ if(MOVE){ SEL.removeAttribute('contenteditable'); showHandle(); } else { hideHandle(); } } }
    else if(d.cmd==='gethtml'){ parent.postMessage({__editor:true,type:'html',html:serialize()},'*'); }
  });

  function serialize(){
    if(HOV)HOV.classList.remove('__ed-hover');
    var liveSel=SEL; if(liveSel){liveSel.classList.remove('__ed-selected');liveSel.removeAttribute('contenteditable');}
    var clone=document.documentElement.cloneNode(true);
    var marked=clone.querySelectorAll('[data-edit-id]');
    for(var i=0;i<marked.length;i++){marked[i].removeAttribute('data-edit-id');marked[i].removeAttribute('contenteditable');marked[i].removeAttribute('data-tx');marked[i].removeAttribute('data-ty');}
    var dec=clone.querySelectorAll('.__ed-selected,.__ed-hover');
    for(var j=0;j<dec.length;j++){dec[j].classList.remove('__ed-selected');dec[j].classList.remove('__ed-hover');if(dec[j].className.trim()==='')dec[j].removeAttribute('class');}
    var ui=clone.querySelectorAll('.__ed-ui'); for(var k=0;k<ui.length;k++){ui[k].remove();}
    var st=clone.querySelector('#__editor_style'); if(st)st.remove();
    var sc=clone.querySelector('#__editor_script'); if(sc)sc.remove();
    if(liveSel){liveSel.classList.add('__ed-selected'); if(!MOVE&&canEditText(liveSel))liveSel.setAttribute('contenteditable','true');}
    return '<!DOCTYPE html>\\n'+clone.outerHTML;
  }

  initIds();
  parent.postMessage({__editor:true,type:'ready'},'*');
  postSections();
})();
`;

export function buildEditSrc(html) {
  if (!html) return "";
  let out = html;
  const style = `<style id="__editor_style">${EDITOR_CSS}</style>`;
  const script = `<script id="__editor_script">${EDITOR_JS}</` + `script>`;
  if (out.includes("</head>")) out = out.replace("</head>", style + "</head>");
  else out = style + out;
  if (out.includes("</body>")) out = out.replace("</body>", script + "</body>");
  else out = out + script;
  return out;
}

export function rgbToHex(rgb) {
  if (!rgb) return "#000000";
  if (rgb.startsWith("#")) return rgb;
  const m = rgb.match(/\d+/g);
  if (!m || m.length < 3) return "#000000";
  const hex = (n) => parseInt(n, 10).toString(16).padStart(2, "0");
  return "#" + hex(m[0]) + hex(m[1]) + hex(m[2]);
}
